import { Autocomplete, Box, Button,  IconButton,  Modal,  TextField, Typography } from '@mui/material';
import './styles.scss'
import Grid from "@mui/material/Grid2";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useEffect, useState } from 'react';
import { Scatter } from 'react-chartjs-2';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import { analyzeGroupOfDyn, calculateProduction, dpiston, Dyn, DynSort } from './sort_dyn';
import UnfoldMoreDoubleIcon from '@mui/icons-material/UnfoldMoreDouble';
import UnfoldLessDoubleIcon from '@mui/icons-material/UnfoldLessDouble';
import { ModalVariables } from './modalVariables';
import { ModalDyn } from './modalDyn';
import { ModalDiagnostic } from './bm_diagnostic/modalDiagnostic';
import { DynsCard } from 'src/stateManagement/redux/slices/location/interfaces';
import { ModalAnalyst } from './modalAnalyst';
import { selectLocationState, useSelector } from "src/stateManagement/redux";

interface Props {
    dynCardList: DynsCard[];
    handleOpenCloseModal?: any;
    showFullModal?: boolean;
    expandCard?: boolean;
    setExpandCard?: any;
}

const ChartWithOptions = ({ dynCardList, handleOpenCloseModal, showFullModal, expandCard, setExpandCard }: Props) => {

    const { wellboreDiagram } = useSelector(selectLocationState);

    const [activeSubCardIndex, secActiveCardSubIndex] = useState(0)

    const [listSortDyns, setListSortDyns] = useState<DynSort[]>()

    const [sortDyns, setSortDyns] = useState<DynSort>()

    const [numberOfCards, setNumberOfCards] = useState(0)

    const [activeDyn, setactiveDyn] = useState<Dyn>()

    const [modalVariables, setModalVariables] = useState(false)

    const [modalDyn, setModalDyn] = useState(false)

    const [modalAnalyst, setModalAnalyst] = useState(false)

    const [modalDiagnostic, setModalDiagnostic] = useState(false)   


    useEffect(() => {
        analyzeGroupOfDyn(dynCardList, wellboreDiagram,sortDyns).then(({enableCard,listSortDyns}) => {            
            setNumberOfCards(enableCard)
            setListSortDyns(listSortDyns)
            secActiveCardSubIndex(0)
            setSortDyns(listSortDyns[0])
        })

    }, [dynCardList, wellboreDiagram])

    useEffect(() => {

        if (sortDyns) {
            
            const activeDyn = sortDyns.dyns[activeSubCardIndex]

            setactiveDyn(activeDyn)
        }

    }, [sortDyns, activeSubCardIndex])

    useEffect(() => {
        if (sortDyns && activeDyn) {
            const production = calculateProduction(sortDyns?.dpluger, sortDyns?.spm, activeDyn?.ept)
            const simpleVariable: any = { ...sortDyns }
            simpleVariable.bbpd = production
            const pumpEfficiency = (sortDyns?.pumpEfficiency || 0)/100            
            simpleVariable.adjustProduction = production * pumpEfficiency
            setSortDyns(simpleVariable)
        }
    }, [activeDyn?.ept, sortDyns?.dpluger, sortDyns?.spm, sortDyns?.pumpEfficiency])


    const onMoveEpt = (option: 'up' | 'down', newValue?: number | undefined) => {

        if (sortDyns === undefined || activeDyn === undefined) return

        if (activeDyn?.mpt === undefined || sortDyns === undefined || activeDyn === undefined) return

        const ept = activeDyn?.ept || 0
        let newEpt = option === 'up' ? ept + 5 : ept - 5

        if (newValue) newEpt = newValue

        if (newEpt < 0) newEpt = 0

        if (newEpt > activeDyn?.mpt) newEpt = activeDyn?.mpt


        const newSortDyns = { ...sortDyns }
        newSortDyns.dyns[activeSubCardIndex].ept = newEpt

        const newEptData = [
            { x: newEpt, y: activeDyn?.bottomMinLoad || 0 },
            { x: newEpt, y: activeDyn?.bottomPeakLoad }
        ]

        const bottomCardDataset = newSortDyns.dyns[activeSubCardIndex].datasetBottom.datasets[0]

        const newEptDataSet = { label: "EPT", data: newEptData, backgroundColor: ["rgb(26, 27, 27)"], showLine: true, borderColor: 'rgb(26, 27, 27)' }

        newSortDyns.dyns[activeSubCardIndex].datasetBottom.datasets = [bottomCardDataset, newEptDataSet]

        setSortDyns(newSortDyns)

    }

    const onChangevalue = (value: any, label: any) => {

        if (sortDyns === undefined) return

        const simpleVariable: any = { ...sortDyns }
        simpleVariable[label] = value
        setSortDyns(simpleVariable)
    }

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top' as const,
                xlabels: "herre"
            },
            tooltip: {
                callbacks: {
                    label: function (context: any) {
                        return context.raw.y;
                    }
                }
            }
        },
        elements: {
            point: {
                pointStyle: 'circle',
                radius: 2,
                // borderWidth:  4,
                borderColor: 'rgba(82, 137, 220, 1)',

            }
        }

    }

    const handleOpenClosevariableModal = () => {
        setModalVariables(!modalVariables)
        setModalDyn(false)
        setModalDiagnostic(false)
    }

    const handleOpenCloseDynModal = () => {
        setModalDyn(!modalDyn)
        setModalVariables(false)
        setModalDiagnostic(false)
    }

    const handleOpenCloseDiagnosticModal = () => {
        setModalDiagnostic(!modalDiagnostic)
        setModalVariables(false)
        setModalDyn(false)
        setModalAnalyst(false)
    }

    const handleOpenCloseAnalystModal = () => {
        setModalAnalyst(!modalAnalyst)
        setModalDiagnostic(false)
        setModalVariables(false)
        setModalDyn(false)
    }

    const handleOnChangeDynActive = (fieldId:string, index: number) => {

       
        try {
            const sortDyn = listSortDyns?.find((sortDyn) => sortDyn.fieldActivityId === fieldId)
            const activeDyn = sortDyn?.dyns[index]

            if (activeDyn) {
                setSortDyns(sortDyn)
                setactiveDyn(activeDyn)
                secActiveCardSubIndex(index)
                setModalDyn(false)
            }
        } catch (error) { }
    }



    return (
        <Box className="card_external_container">
            {sortDyns && (
                <ModalVariables
                    sortDyns={sortDyns}
                    open={modalVariables}
                    onClose={handleOpenClosevariableModal}
                />
            )}
            {listSortDyns && (
                <ModalDyn
                    listSortDyns={listSortDyns}
                    open={modalDyn}
                    onClose={handleOpenCloseDynModal}
                    onChangeDyn={handleOnChangeDynActive}
                />
            )}
            {listSortDyns && (
                <ModalDiagnostic
                    open={modalDiagnostic}
                    onClose={handleOpenCloseDiagnosticModal}
                    sortDyns={sortDyns}
                    activeDyn={activeDyn}
                    listSortDyns={listSortDyns}
                />
            )}
            {listSortDyns && (
                <ModalAnalyst
                    open={modalAnalyst}
                    onClose={handleOpenCloseAnalystModal}
                    sortDyns={sortDyns}
                    activeDyn={activeDyn}
                    listSortDyns={listSortDyns}
                />
            )}
            {/* header */}
            <Grid className="card_header">
                <Grid
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <IconButton
                        aria-haspopup="true"
                        color="inherit"
                        size="small"
                        onClick={() => handleOpenCloseModal()}
                    >
                        {showFullModal ? (
                            <CloseFullscreenIcon
                                color="primary"
                                style={{ transform: "rotate(90deg)" }}
                            />
                        ) : (
                            <OpenInFullIcon
                                color="primary"
                                style={{ transform: "rotate(90deg)" }}
                            />
                        )}
                    </IconButton>
                    <IconButton
                        size="small"
                        color="primary"
                        sx={{ transform: "rotate(90deg)" }}
                        onClick={() => setExpandCard(!expandCard, "card")}
                    >
                        {expandCard ? (
                            <UnfoldLessDoubleIcon />
                        ) : (
                            <UnfoldMoreDoubleIcon />
                        )}
                    </IconButton>
                </Grid>
                <Grid className="card_header_sub_elements">
                    <Grid>
                        <TextField
                            id="variable"
                            size="small"
                            label="Surface Peak Load"
                            value={
                                typeof activeDyn?.surfacePeakLoad === "number"
                                    ? activeDyn.surfacePeakLoad.toFixed(2)
                                    : 0
                            }
                            fullWidth
                        />
                    </Grid>
                    <Grid>
                        <TextField
                            id="variable"
                            size="small"
                            label="Surface Min Load"
                            value={
                                typeof activeDyn?.surfaceMinLoad === "number"
                                    ? activeDyn.surfaceMinLoad.toFixed(2)
                                    : 0
                            }
                            fullWidth
                        />
                    </Grid>
                    <Grid>
                        <TextField
                            id="variable"
                            size="small"
                            label="Bottom Peak Load"
                            value={
                                typeof activeDyn?.bottomPeakLoad === "number"
                                    ? activeDyn.bottomPeakLoad.toFixed(2)
                                    : 0
                            }
                            fullWidth
                        />
                    </Grid>
                    <Grid>
                        <TextField
                            id="variable"
                            size="small"
                            label="Bottom Min Load"
                            value={
                                typeof activeDyn?.bottomMinLoad === "number"
                                    ? activeDyn.bottomMinLoad.toFixed(2)
                                    : 0
                            }
                            fullWidth
                        />
                    </Grid>
                    <Grid>
                        <TextField
                            id="variable"
                            size="small"
                            label="% Carga Estructural"
                            value={
                                typeof activeDyn?.currentPercentageMaxLoad ===
                                "number"
                                    ? activeDyn.currentPercentageMaxLoad.toFixed(
                                          2
                                      )
                                    : 0
                            }
                            fullWidth
                        />
                    </Grid>
                </Grid>
                <Grid
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                        justifyContent: "center",
                        alignItems: "center",
                        padding: 1,
                    }}
                >
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        sx={{
                            width: "70px",
                            fontSize: "10px",
                            fontWeight: "bold",
                        }}
                        onClick={handleOpenClosevariableModal}
                    >
                        Variables
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        sx={{
                            width: "70px",
                            fontSize: "10px",
                            fontWeight: "bold",
                        }}
                        onClick={handleOpenCloseAnalystModal}
                    >
                        Analista
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        sx={{
                            width: "70px",
                            fontSize: "10px",
                            fontWeight: "bold",
                        }}
                        onClick={handleOpenCloseDynModal}
                    >
                        Dyns ({numberOfCards})
                    </Button>
                </Grid>
            </Grid>
            {/* Body */}
            <Grid className="card_body_container">
                {/* card */}
                <Grid className="card_graph">
                    <Grid className="card_graph">
                        <Grid size={12}>
                            {activeDyn?.datasetSurface && (
                                <Scatter
                                    options={options}
                                    data={activeDyn?.datasetSurface}
                                />
                            )}
                        </Grid>
                        <Grid size={12}>
                            {activeDyn?.datasetBottom && (
                                <Scatter
                                    options={{
                                        ...options,
                                        onClick: (event, elements) => {
                                            if (elements.length > 0) {
                                                const { index } = elements[0];
                                                const dataPoint =
                                                    activeDyn.datasetBottom
                                                        .datasets[0].data[
                                                        index
                                                    ];
                                                onMoveEpt("up", dataPoint.x);
                                            }
                                        },
                                    }}
                                    data={activeDyn?.datasetBottom}
                                />
                            )}
                        </Grid>
                    </Grid>
                </Grid>
                {/* right options */}
                <Grid className="card_body_right_container">
                    <Grid>
                        <Grid className="card_body_right_sub_elements">
                            <Grid>
                                <TextField
                                    id="variable"
                                    size="small"
                                    label="SPM"
                                    value={
                                        typeof sortDyns?.spm === "number"
                                            ? sortDyns.spm.toFixed(2)
                                            : 0
                                    }
                                    fullWidth
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    id="variable"
                                    size="small"
                                    label="Stroke Length"
                                    value={
                                        typeof activeDyn?.strokeLength ===
                                        "number"
                                            ? activeDyn.strokeLength.toFixed(2)
                                            : 0
                                    }
                                    fullWidth
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    id="variable"
                                    size="small"
                                    label="MPT"
                                    value={
                                        typeof activeDyn?.mpt === "number"
                                            ? activeDyn.mpt.toFixed(2)
                                            : 0
                                    }
                                    fullWidth
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    id="variable"
                                    size="small"
                                    label="EPT"
                                    value={
                                        typeof activeDyn?.ept === "number"
                                            ? activeDyn.ept.toFixed(2)
                                            : 0
                                    }
                                    fullWidth
                                />
                            </Grid>
                            <Grid>
                                <Autocomplete
                                    fullWidth
                                    disablePortal
                                    size="small"
                                    value={
                                        dpiston?.find(
                                            (dp) => dp.id === sortDyns?.dpluger
                                        ) || dpiston[0]
                                    }
                                    options={dpiston}
                                    onChange={(event: any, newValue: any) =>
                                        onChangevalue(newValue?.id, "dpluger")
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={
                                                <Typography>
                                                    <span
                                                        style={{
                                                            fontSize: "1.2em",
                                                        }}
                                                    >
                                                        ø
                                                    </span> Piston
                                                </Typography>
                                            }
                                            fullWidth
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    id="variable"
                                    size="small"
                                    label="Producción Bruta"
                                    value={
                                        typeof sortDyns?.bbpd === "number"
                                            ? sortDyns.bbpd.toFixed(2)
                                            : 0
                                    }
                                    fullWidth
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    id="variable"
                                    size="small"
                                    label="Eficiencia"
                                    onChange={(e) => {
                                        const value =
                                            parseFloat(
                                                e.target.value.replace(
                                                    /[^0-9.]/g,
                                                    ""
                                                )
                                            ) || 0;
                                        if (value >= 0 && value <= 100) {
                                            onChangevalue(
                                                value,
                                                "pumpEfficiency"
                                            );
                                        }
                                    }}
                                    value={
                                        typeof sortDyns?.pumpEfficiency ===
                                        "number"
                                            ? sortDyns.pumpEfficiency.toFixed(0)
                                            : 0
                                    }
                                    fullWidth
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    id="variable"
                                    size="small"
                                    label="Producción Ajustada"
                                    value={
                                        typeof sortDyns?.adjustProduction ===
                                        "number"
                                            ? sortDyns.adjustProduction.toFixed(
                                                  2
                                              )
                                            : 0
                                    }
                                    fullWidth
                                />
                            </Grid>
                        </Grid>

                        <Grid
                            mb={1}
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 1,
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: 12,
                                    fontWeight: "bold",
                                    textAlign: "center",
                                }}
                            >
                                Llenado
                            </Typography>
                            <Grid>
                                <IconButton
                                    size="small"
                                    color="inherit"
                                    onClick={() => onMoveEpt("down")}
                                >
                                    <ArrowBackIosIcon color="primary" />
                                </IconButton>
                                <IconButton
                                    size="small"
                                    color="inherit"
                                    onClick={() => onMoveEpt("up")}
                                >
                                    <ArrowForwardIosIcon color="primary" />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        sx={{
                            width: "95px",
                            fontSize: "11px",
                            fontWeight: "bold",
                        }}
                        onClick={handleOpenCloseDiagnosticModal}
                    >
                        Diagnosticar
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export const Graphics = ({ dynCardList, expandCard, setExpandCard }: { dynCardList: any, expandCard: boolean, setExpandCard: any }) => {

    const [showFullModal, setshowFullModal] = useState(false)

    const handleOpenCloseModal = () => {
        setshowFullModal(!showFullModal)
    }

    return (
        <>
            <Modal
                open={showFullModal}
                onClose={handleOpenCloseModal}
            >
                <>
                    <ChartWithOptions dynCardList={dynCardList} handleOpenCloseModal={handleOpenCloseModal} showFullModal={showFullModal} setExpandCard={setExpandCard} expandCard={expandCard} />
                </>
            </Modal>
            <ChartWithOptions dynCardList={dynCardList} handleOpenCloseModal={handleOpenCloseModal} showFullModal={showFullModal} setExpandCard={setExpandCard} expandCard={expandCard} />
        </>
    )
}

